import React from "react";
import { UserController } from "./UserController";
import { UserViewModel } from "./UserViewModel";
import * as feedback from "../../common/Feedback/Feedback";
import * as log from "../../common/Feedback/Log";

export class UserProvider extends React.Component {
  constructor(props) {
    super(props);
    this.viewModel = new UserViewModel();
    this.logger = log;
    this.feedback = feedback;

    console.log(props);
  }

  render() {
    return (
      <UserController
        viewModel={this.viewModel}
        log={this.logger}
        feedback={this.feedback}
        toggleTopbar={this.props.toggleTopbar}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/User/UserProvider.js